export default {
  setConfig(state, data) {
    state.config = data;
  },
  setSlides(state, data) {
    state.slides = data;
  },
  setServices(state, data) {
    state.services = data;
  },
  setServicesById(state, data) {
    state.servicesById = data;
  },
  setPoster(state, data) {
    state.poster = data;
  },
  setSupport(state, data) {
    state.support = data;
  },

  setContactUs(state, data) {
    state.contactUs = data;
  },
  setAboutUs(state, data) {
    state.aboutUs = data;
  },
  setSocialNetwork(state, data) {
    state.socialNetwork = data;
  },
  setMenu(state, data) {
    state.menu = data;
  },

  setTutorials(state, data) {
    state.tutorials = data;
  },
  setTutorialsPage(state, data) {
    state.tutorialsPage = data;
  },
  setTutorial(state, data) {
    state.tutorial = data;
  },
  setTutorialsPageTotal(state, data) {
    state.tutorialsPageTotal = data;
  },
  setRelatedTutorials(state, data) {
    state.relatedTutorials = data;
  },
  setCategories(state, data) {
    state.categories = data;
  },

  setGalleries(state, data) {
    state.galleries = data;
  },
  setGalleryPage(state, data) {
    state.galleryPage = data;
  },
  setGallery(state, data) {
    state.gallery = data;
  },
  setGalleryList(state, data) {
    state.galleryList = data;
  },
  setGalleryPageTotal(state, data) {
    state.galleryPageTotal = data;
  },

  setProducts(state, data) {
    state.products = data;
  },
  setProductsHome(state, data) {
    state.productsHome = data;
  },
  setProductsPage(state, data) {
    state.productsPage = data;
  },
  setProduct(state, data) {
    state.product = data;
  },
  setProductsPageTotal(state, data) {
    state.productsPageTotal = data;
  },
  setRelatedProducts(state, data) {
    state.relatedProducts = data;
  },

  setBlogs(state, data) {
    state.blogs = data;
  },
  setRelatedBlogs(state, data) {
    state.relatedBlogs = data;
  },
  setBlogHome(state, data) {
    state.blogHome = data;
  },
  setBlogsPage(state, data) {
    state.blogsPage = data;
  },
  setBlogsPageTotal(state, data) {
    state.blogsPageTotal = data;
  },
  setBlog(state, data) {
    state.blog = data;
  },
  setComments(state, data) {
    state.comments = data;
  },
  setNewsLetters(state, data) {
    state.newsLetters = data;
  },
  setRules(state, data) {
    state.rules = data;
  },
  setActivityFields(state, data) {
    state.activityFields = data;
  },
  setProvince(state, data) {
    state.province = data;
  },

  setCity(state, data) {
    state.city = data;
  },
  setCustomerOpinion(state, data) {
    state.customerOpinion = data;
  },
  setCustomerBanners(state, data) {
    state.customerBanners = data;
  },
  setTeam(state, data) {
    state.team = data;
  },
  setPoolSessions(state, data) {
    state.poolSessions = data;
  },
};
